<template>
  <div class="group-label">{{ text }}</div>
</template>

<script>
export default {
  name: 'AcademyInputGroupLabel',
  props: {
    text: {
      type: String,
      require: true,
    },
  },
}
</script>

<style lang="scss" scope>
@import '../../../../../sass/commons/commonVariables.scss';

.group-label {
  font-size: 12px;
  line-height: 1;
  padding: 10px 15px;
  color: $academy_purple;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: -100%;
    right: -100%;
    z-index: -1;
    background: $academy_purple2;
  }
  @include mq('w580') {
    max-width: 360px;
    padding: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/InputGroupLabel.vue